import React, { useState } from 'react'
import { colors } from './fieldTheme'
import { InfoIcon } from './FieldIcons'
import { StickyActionBar, SaveInventoryButton } from './FieldUI'
import { InventoryIdentity, CloseButton, LeaveSheet } from './FieldThemes'
import FieldPhotoPicker from './FieldPhotoPicker'

// Emplacement sans modèle d'inventaire (canvas W7f, décision 7) : photos et commentaire seulement.
// Même ajout de photos que les thèmes (bouton puis volet W9), pour un seul geste dans toute l'app.

export default function FieldNoModel({ type, pitch, stay, client, comment, photos, user, saving, saveError, onCommentChange, onPhotosChange, onSave, onClose, onSaveLater, savingLater, saveLaterError, restored })
{
	const [leaveOpen, setLeaveOpen] = useState(false)
	const dirty = comment.trim() !== '' || photos.length > 0

	return (
		<div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
			<div style={{ display: 'flex', alignItems: 'center', minHeight: 56, padding: '4px 20px 0' }}>
				<CloseButton onClick={() => (dirty ? setLeaveOpen(true) : onClose())} />
			</div>
			<InventoryIdentity type={type} pitch={pitch} stay={stay} client={client} />

			<div role="note" style={{ margin: '24px 20px 0', display: 'flex', alignItems: 'flex-start', gap: 14, padding: 20, borderRadius: 18, background: '#E8EBF5', color: colors.textSecondary }}>
				<InfoIcon size={28} />
				<span style={{ fontSize: 17, fontWeight: 600, color: colors.text, lineHeight: 1.35 }}>Pas de liste d'objets pour cet emplacement : photos et commentaire seulement.</span>
			</div>

			<h2 style={{ fontSize: 15, fontWeight: 700, color: colors.textSecondary, letterSpacing: '.04em', textTransform: 'uppercase', padding: '32px 20px 12px' }}>Photos</h2>
			<div style={{ padding: '0 20px' }}>
				<FieldPhotoPicker photos={photos} user={user} onChange={onPhotosChange} />
			</div>

			<label htmlFor="field-nomodel-comment" style={{ display: 'block', fontSize: 15, fontWeight: 700, color: colors.textSecondary, letterSpacing: '.04em', textTransform: 'uppercase', padding: '32px 20px 12px' }}>Commentaire</label>
			<div style={{ padding: '0 20px 32px' }}>
				<textarea
					id="field-nomodel-comment"
					rows={4}
					className="browser-default"
					value={comment}
					placeholder={'Ce que vous avez constaté sur ' + pitch.location}
					onChange={(e) => onCommentChange(e.target.value)}
					style={{ width: '100%', minHeight: 128, margin: 0, padding: '14px 16px', borderRadius: 18, border: '2px solid ' + colors.border, background: colors.surface, fontSize: 17, lineHeight: 1.45, fontFamily: 'inherit', color: colors.text, resize: 'vertical', boxSizing: 'border-box' }}
				/>
			</div>

			<StickyActionBar>
				<SaveInventoryButton saving={saving} saveError={saveError} onSave={onSave} />
			</StickyActionBar>
			{leaveOpen && <LeaveSheet onLeave={onClose} onStay={() => setLeaveOpen(false)} onSaveLater={onSaveLater} saving={savingLater} saveError={saveLaterError} restored={restored} />}
		</div>
	)
}
